import React, { Fragment, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import OrderForm, { IOrderFormProps } from "../OrderBrowser/OrderForm";
import { TApiOrderDetails } from "../../api/endpoints/Order";
import { FormikProps } from "formik";
import { noop } from "lodash";

interface IProps {
  formik?: FormikProps<any>;
  orderProps: IOrderFormProps['orderProps'];
  onSuccess?: (order: TApiOrderDetails) => void;
  disabled?: boolean;
}

export interface ICreateOrderButtonProps extends IProps {
}

const CreateOrderButton = (props: IProps) => {
  const { formik, orderProps, onSuccess, disabled } = props;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleClick = () => {
    if (formik) {
      formik.submitForm().then(() => {
        if (formik.isValid) {
          setShow(true);
        }
      }).catch(noop);
    } else {
      setShow(true);
    }
  }

  const onSubmit = (order: TApiOrderDetails) => {
    handleClose();
    onSuccess && onSuccess(order);
  }

  return (
    <Fragment>
      <Button variant="primary" onClick={handleClick} disabled={disabled}>
        Create order
      </Button>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create new order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderForm orderProps={orderProps} onSubmit={onSubmit} />
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default CreateOrderButton;
